<template>
  <div>
    <div class="tr">
      <el-button
        :disabled="!menuCode"
        type="primary"
        icon="plus"
        @click="$router.push(`${$route.path}/add/${menuCode}`)"
      >新建</el-button>
    </div>
    <div class="pr" style="z-index: 0;">
      <el-table
        v-loading="tableLoading"
        :data="tableData"
      >
        <el-table-column
          prop="description"
          label="按钮名称"
        ></el-table-column>
        <el-table-column
          prop="widgetId"
          label="按钮Key"
          :formatter="slicePart"
        ></el-table-column>
        <el-table-column
          prop="seqNum"
          label="排序号"
        ></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$router.push(`${$route.path}/edit/${row.buttonId}`)">配置</el-button>
            <el-button type="text" @click="deleteMenu(row.buttonId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        v-if="page.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNo"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {system} from '../../api'

export default {
  name: 'ButtonList',

  props: {
    menuCode: String
  },

  mounted () {
    if (this.menuCode) this.getTableData()
  },

  watch: {
    menuCode (value) {
      if (value) this.getTableData()
    }
  },

  data () {
    return {
      tableData: [],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },

  methods: {
    slicePart (row) {
      return row.widgetId.split('-')[1]
    },
    deleteMenu (sysButtonId) {
      this.$confirm('确定要删除这个按钮吗？', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await system.deleteButton(sysButtonId)
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '按钮删除成功'
          })
          this.getTableData()
        } else {
          this.$message({
            type: 'error',
            message: msg
          })
        }
      }, err => {
        console.log(err)
      })
    },
    async getTableData () {
      this.tableLoading = true
      let {data, page} = await system.getButtonList({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        menuCode: this.menuCode
      })
      this.tableLoading = false
      this.tableData = data
      this.page.pageNo = page.pageNum
      this.page.total = page.total
    },
    handleSizeChange (newPageSize) {
      this.page.pageSize = newPageSize
      this.getTableData()
    },
    handleCurrentChange (newPageNo) {
      this.page.pageNo = newPageNo
      this.getTableData()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
